'use client'
import { useEffect } from 'react'

export function HydrationMarker() {
  useEffect(() => {
    document.body.classList.add('hydrated')
    // Do NOT call .remove() on #spa-loading — that node is in React's fiber tree.
    // Direct DOM removal causes insertBefore/removeChild crashes on next reconciliation.
    // CSS (.hydrated #spa-loading) already hides it via opacity/display transition.
  }, [])
  return null
}
